import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function passwordMatchValidator(
  controlName: string,
  repeatControlName: string,
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const passwordControl = control.get(controlName);
    const passwordRepeatControl = control.get(repeatControlName);

    if (!passwordControl || !passwordRepeatControl) {
      return { passwordMatch: true };
    }

    if (passwordRepeatControl.errors && !passwordRepeatControl.errors['passwordMatch']) {
      // Return if another validator has already found an error on the passwordRepeat control
      return null;
    }

    if (passwordControl.value !== passwordRepeatControl.value) {
      passwordRepeatControl.setErrors({ passwordMatch: true });
    } else {
      passwordRepeatControl.setErrors(null);
    }

    return null;
  };
}
